import { useState, useEffect } from 'react';
import { UsernameUniquenessService } from '../UsernameUniquenessService';

export function useUsernameUniqueness(username: string) {
  const [isUnique, setIsUnique] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!username) {
      setIsUnique(null);
      return;
    }
    setLoading(true);
    const handler = setTimeout(async () => {
      try {
        const unique = await UsernameUniquenessService.getInstance().checkUsernameUnique(username);
        setIsUnique(unique);
      } catch {
        setIsUnique(null);
      } finally {
        setLoading(false);
      }
    }, 500);
    return () => clearTimeout(handler);
  }, [username]);

  return { isUnique, loading };
}
